<template>
    <div>
      <div class="page-header-title">{{Title}}</div>
      <div style="border-bottom: 1px solid #e8eaec;margin-bottom:16px;"></div>
      <Tabs :animated="false"  type="card" >
          <TabPane :label="getLabel(lang=='zh'? item.chName : item.enName,item,index)" :name="item.enName" v-for="(item,index) in menuList" :key="index">
              <component ref="currentTabComponent" v-bind:is="item.enName" :componentMsg="componentMsg" @getState="getState"></component>
          </TabPane>
      </Tabs>
      <Spin size="large" fix v-if="loading"> </Spin>
    </div>
</template>

<script>
import axios from 'axios'
import BasicInformation from './components/BasicInformation'
import PersonnelInformation from './components/PersonnelInformation'
import SocialRelationship from './components/SocialRelationship'
import ContractInformation from './components/ContractInformation'
import AgencyService from './components/AgencyService'
import HealthInformation from './components/HealthInformation'
import WorkExperience from './components/WorkExperience'
import EducationBackground from './components/EducationBackground'
import SkillInformation from './components/SkillInformation'
import TrainingRecord from './components/TrainingRecord'
import EvaluationRecord from './components/EvaluationRecord'
import CorporateAssets from './components/CorporateAssets'
import PunishmentRecords from './components/PunishmentRecords'
import OrgPosition from './components/OrgPosition'
import DocumentsList from './components/DocumentsList'
import CareerDevelopment from './components/CareerDevelopment'
// import CustomList from './components/CustomList'
export default {
    components:{
        BasicInformation,
        PersonnelInformation,
        SocialRelationship,
        ContractInformation,
        AgencyService,
        HealthInformation,
        WorkExperience,
        EducationBackground,
        SkillInformation,
        TrainingRecord,
        EvaluationRecord,
        CorporateAssets,
        PunishmentRecords,
        OrgPosition,
        DocumentsList,
        CareerDevelopment
        // CustomList
    },
    data(){
        return{
            loading:false,
            componentMsg:0,
            menuList:[],
            formItem:'',
            state:false,
            plan:false,
            isEmployeeRecord:false,
            Title:"个人档案",
            userId:'',
        }
    },
    mounted() {
        this.$nextTick(()=> {
            if (!this.emp_code) {
                this.getEmcode();
            }
        })
    },
    computed: {
      //国际化监听
      lang () {
        return this.$store.getters.selectLangeData
      }
    },
    created(){
        let userInfo=JSON.parse(sessionStorage.getItem('userInfo'))
        this.userId = userInfo.userId
        this.plan=this.$route.query.plan || false
        this.getTabsData()
    },
    methods:{
        getTabsData(){
            this.loading=true
            let obj = { 
                beShowSelf:this.plan ? "0" : "1",
                beShowUser:this.plan ? "1" : "0",
                sheetType : "0",
            }
            axios.post("/UserSheet/selectUserSheetSet", obj).then((res) => {
                this.loading=false
                if(res){
                   this.menuList=res
                   this.$nextTick(()=> {
                        this.$refs.currentTabComponent[0].getData(this.menuList[0].sheetId,this.plan)
                        if(this.plan != false){
                          this.Title = "员工档案"
                        }
                    })
                   
                } 
            })
        },
        getState(state){
            this.state=state
        },
        getLabel(label, item ,index) {
            var that = this;
            return h => {
                return h(
                "div",
                {
                    style: { padding: "5px 16px 4px" },
                    on: {
                    click: e => {
                        console.log(index)
                        // console.log(that.formItem)
                        that.$refs.currentTabComponent[index].getData(item.sheetId,this.plan)
                        // if(this.state){
                        //     console.log("离开");
                        //     that.$nextTick(()=> {
                        //         that.formItem =JSON.stringify(this.$refs.currentTabComponent[index].formItem)
                        //         that.$refs.currentTabComponent[index].getData()
                        //     })
                        //     this.state=false
                        // }else {
                        //     if (newForm==that.formItem) {
                        //         console.log("离开");
                        //         that.$nextTick(()=> {
                        //             that.formItem =JSON.stringify(this.$refs.currentTabComponent[index].formItem)
                        //             that.$refs.currentTabComponent[index].getData()
                        //         })
                        
                        //     } else {
                        //         that.$Modal.confirm({
                        //             content: '<p>111</p>',
                        //             okText: 'OK',
                        //             cancelText: 'Cancel'
                        //         });
                        //         e.stopPropagation();
                        //     }
                        // }
                        
                    }
                    }
                },
                label
                );
            };
        },
        getEmcode(){}
    }
}
</script>

<style lang="scss" scoped>
// /deep/ .default-card >>> .ivu-col {
//     padding: 0px 0px !important;
// }
// /deep/ .default-card {
//     padding: 0px 0px !important;
// }
.page-header-title {
  color: #17233d;
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 16px;
}
.ivu-menu {
  display: flex;
  margin-bottom: 20px;
}
.ivu-menu-item {
    white-space: nowrap;
}
.bottomBtn {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
/deep/.ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab {
    padding:0
}
</style>


// WEBPACK FOOTER //
// src/components/process/MyQuery/PersonalFiles.vue